export class FunctionsResource {
  id: number;
  description: string;
}